import moment from 'moment'
import api from './api'

var EventBus = require('eventbusjs')
let TOKEN_CHANGE_EVENT = 'TOKEN_CHANGE_EVENT'

class Service {

  constructor () {
    this.token = this.loadVar('token')
    this.refreshToken = this.loadVar('refreshToken')
    this.tokenExpiresIn = this.loadVar('token_expires_in')
    this.refreshTokenPromise = null
  }

  getToken () {
    return new Promise((resolve, reject) => {
      if (!this.token) {
        return this.askNewToken(resolve, reject)
      }
      if (this.hasValidToken()) {
        return resolve(this.token)
      }
      this.askNewToken(resolve, reject)
    })
  }

  getLastToken () {
    if (!this.token) {
      return ''
    }
    if (this.hasValidToken()) {
      return this.token
    }
    return ''
  }

  askNewToken (resolve = () => {}, reject = () => {}) {
    if (!this.refreshToken) {
      return reject()
    }
    if (this.refreshTokenPromise) {
      return this.refreshTokenPromise.then(() => resolve(this.token)).catch(reject)
    }
    this.refreshTokenPromise = api.get(process.env.auth.refreshPath, {
      __noToken: true,
      params: {
        refresh_token: this.refreshToken
      }
    }).then((response) => {
      this.refreshTokenPromise = null
      this.setToken(response.data.access_token, response.data.expires_in, response.data.refresh_token)
      resolve(this.token)
    }).catch((error) => {
      this.refreshTokenPromise = null
      if (!error.response || !error.response.data || (error.response.data.error !== 'invalid_grant' && error.response.data.error !== 'expired_token')) {
        return
      }
      this.cleanToken()
      reject()
    })
  }

  setToken (token, tokenExpiresIn, refreshToken) {
    this.token = token
    this.saveVar('token', token)
    this.tokenExpiresIn = moment().add(tokenExpiresIn, 'seconds').unix()
    this.saveVar('token_expires_in', this.tokenExpiresIn)
    this.refreshToken = refreshToken
    this.saveVar('refreshToken', refreshToken)
    EventBus.dispatch(TOKEN_CHANGE_EVENT)
  }

  loadVar (name) {
    try {
      return JSON.parse(localStorage.getItem(name))
    } catch (e) {
      return ''
    }
  }

  saveVar (name, value) {
    return localStorage.setItem(name, JSON.stringify(value))
  }

  cleanToken () {
    this.setToken(null, null, null)
  }

  hasValidToken () {
    return this.token && moment.unix(this.tokenExpiresIn).isAfter(moment().add(5, 'seconds'))
  }

  onTokenChange (fn) {
    EventBus.addEventListener(TOKEN_CHANGE_EVENT, fn)
  }

  offTokenChange (fn) {
    EventBus.removeEventListener(TOKEN_CHANGE_EVENT, fn)
  }
}
let service = new Service()
window.authService = service
export default service



// WEBPACK FOOTER //
// ./src/utils/authService.js